export const AUDIT_LOG_QUERY = "auditLog/AUDIT_LOG_QUERY";
export const AUDIT_LOG_LOADED = "auditLog/AUDIT_LOG_LOADED";
export const AUDIT_LOG_LOAD_FAILED = "auditLog/AUDIT_LOG_LOAD_FAILED";
export const RESET = "auditLog/RESET";
